import { render, staticRenderFns } from "./FeaturedProgramCard.vue?vue&type=template&id=2dedc26e&scoped=true&"
import script from "./FeaturedProgramCard.vue?vue&type=script&lang=js&"
export * from "./FeaturedProgramCard.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProgramCard.vue?vue&type=style&index=0&id=2dedc26e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dedc26e",
  null
  
)

export default component.exports